import React, { useState } from 'react';
import styles from './NotePopup.module.css';

const NotePopup = ({ targetId, targetName = "Mountain", itemName, onClose, onSubmit, allowPermanent = false }) => {
  const [category, setCategory] = useState('conditions');
  const [content, setContent] = useState('');
  const [featureDuration, setFeatureDuration] = useState(allowPermanent ? null : '24h');

  const handleSubmit = () => {
    if (!content.trim()) {
      alert('Note content cannot be empty.');
      return;
    }
    onSubmit({ targetId, category, content, featureDuration });
    onClose();
  };

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <h2>Add a Note for {itemName || `${targetName} ${targetId}`}</h2>
        <div className={styles.formGroup}>
          <label htmlFor="category">Category:</label>
          <select
            id="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className={styles.selectInput}
          >
            <option value="conditions">Conditions</option>
            <option value="crowd">Crowd</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="content">Note:</label>
          <textarea
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value.slice(0, 250))}
            placeholder="Write your note here..."
            className={styles.textareaInput}
            rows="5"
            maxLength="250"
          />
          <div style={{ fontSize: '0.85rem', color: 'var(--text-color)', marginTop: '0.25rem', opacity: 0.7 }}>
            {content.length}/250 characters
          </div>
        </div>

        <div className={styles.formGroup}>
          <label>Feature Duration:</label>
          <div className={styles.featureOptions}>
            {allowPermanent && (
              <button
                className={`${styles.featureButton} ${featureDuration === null ? styles.selected : ''}`}
                onClick={() => setFeatureDuration(null)}
              >
                Permanent
              </button>
            )}
            <button
              className={`${styles.featureButton} ${featureDuration === '24h' ? styles.selected : ''}`}
              onClick={() => setFeatureDuration('24h')}
            >
              24 Hours
            </button>
            <button
              className={`${styles.featureButton} ${featureDuration === '7d' ? styles.selected : ''}`}
              onClick={() => setFeatureDuration('7d')}
            >
              7 Days
            </button>
            <button
              className={`${styles.featureButton} ${featureDuration === '30d' ? styles.selected : ''}`}
              onClick={() => setFeatureDuration('30d')}
            >
              30 Days
            </button>
          </div>
        </div>

        <div className={styles.buttonGroup}>
          <button onClick={onClose} className={styles.cancelButton}>
            Cancel
          </button>
          <button onClick={handleSubmit} className={styles.submitButton}>
            Add Note
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotePopup;